import { createSlice } from "@reduxjs/toolkit"

export const inactiveAdsSlice = createSlice({
	name: "inactive_ads",
	initialState: {
		inactiveAds: "",
		errors: [],
	},

	reducers: {
        getInactiveAds: (state, action) => {
        
			state.inactiveAds = action.payload
		},
		getInactiveAdsList: (state, action) => {
        
			state.inactiveAds = action.payload
		},
		getErrors: (state, action) => {
        
			state.errors = action.payload
		},
	},
})
export const {getInactiveAds, getInactiveAdsList, getErrors} = inactiveAdsSlice.actions

export default inactiveAdsSlice.reducer
